import { render, staticRenderFns } from "./CardBalanceMiniCard.vue?vue&type=template&id=a10ce63a&"
import script from "./CardBalanceMiniCard.vue?vue&type=script&lang=js&"
export * from "./CardBalanceMiniCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports